import React from 'react';
import { GlassCard } from '../ui/GlassCard';
import type { Job } from '../../data/jobs';

interface JobCardProps {
  job: Job;
  onClick: () => void;
  delay?: number;
}

const getEmploymentTypeBadge = (type: string) => {
  const baseClasses = "px-3 py-1 rounded-full text-xs font-medium";
  
  switch (type) {
    case 'Intern':
      return `${baseClasses} bg-blue-100 text-blue-800 border border-blue-300`;
    case 'Part-time':
      return `${baseClasses} bg-green-100 text-green-800 border border-green-300`;
    case 'Full-time':
      return `${baseClasses} bg-purple-100 text-purple-800 border border-purple-300`;
    default:
      return `${baseClasses} bg-gray-100 text-gray-800 border border-gray-300`;
  }
};

export const JobCard: React.FC<JobCardProps> = ({ job, onClick, delay = 0 }) => {
  return (
    <GlassCard
      onClick={onClick}
      hover={true}
      delay={delay}
      className="p-6 space-y-4"
    >
      <div className="flex justify-between items-start">
        <h3 className="text-xl font-semibold text-gray-800 group-hover:text-blue-700 transition-colors">
          {job.title}
        </h3>
        <span className={getEmploymentTypeBadge(job.employmentType)}>
          {job.employmentType}
        </span>
      </div>
      
      <p className="text-gray-700 leading-relaxed">
        {job.description}
      </p>
      
      <div className="flex justify-between items-center pt-2">
        <span className="text-sm text-gray-600 font-medium">
          {job.category}
        </span>
        <span className="text-gray-600 text-sm">
          Learn more →
        </span>
      </div>
    </GlassCard>
  );
}; 